import React from "react";
import { Board } from "../Board/Board";
function Home() {
  return (
    <div className="home-page">
      <Board />
    </div>
  );
}

export default Home;
